<template>
  <div id="text">
    <span>时间：</span>
    <mark
      style="
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0);
        z-index: 999;
      "
      v-show="showPreSeason || showEndSeason"
      @click.stop="
        showPreSeason = false;
        showEndSeason = false;
      "
    ></mark>
    <el-input
      class="jiance_phone_date_1"
      readonly
      placeholder="请选择季度"
      v-model="showPreValue"
      style="width: 150px"
      @focus="showPreSeason = true"
    >
      <i slot="prefix" class="el-input__icon el-icon-date"></i>
    </el-input>
    <span>-</span>
    <el-input
      readonly
      class="rightInputBox jiance_phone_date_1"
      placeholder="请选择季度"
      v-model="showEndValue"
      style="width: 150px"
      @focus="showEndSeason = true"
    >
      <i slot="prefix" class="el-input__icon el-icon-date"></i>
    </el-input>
    <el-card
      class="box-card box-card_left"
      style="
        width: 220px;
        padding: 0 3px 20px;
        margin-left: 46px;
        margin-top: 5px;
        z-index: 9999;
        position: absolute;
      "
      v-show="showPreSeason"
    >
      <div
        slot="header"
        class="clearfix"
        style="text-align: center; padding: 0"
      >
        <button
          type="button"
          aria-label="前一年"
          class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
          :disabled="showEndSeason && endYear <= preYear"
          @click="prev"
        ></button>
        <span
          v-if="showPreSeason"
          role="button"
          class="el-date-picker__header-label"
          >{{ preYear }}年</span
        >
        <span
          v-if="showEndSeason"
          role="button"
          class="el-date-picker__header-label"
          >{{ endYear }}年</span
        >
        <button
          type="button"
          aria-label="后一年"
          @click="next"
          class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
          :disabled="showPreSeason && preYear >= endYear"
        ></button>
      </div>
      <div class="text item" style="text-align: center">
        <el-button
          type="text"
          size="medium"
          :class="
            showDisabled(
              preYear > maxYear ||
                (preYear === maxYear && currSeason < 1) ||
                (preYear === endYear && endSeason < 1),
              'left'
            )
          "
          :disabled="
            preYear > maxYear ||
            (preYear === maxYear && currSeason < 1) ||
            (preYear === endYear && endSeason < 1)
          "
          @click="selectSeason(0)"
          >第一季度</el-button
        >
        <el-button
          type="text"
          size="medium"
          :class="
            showDisabled(
              preYear > maxYear ||
                (preYear === maxYear && currSeason < 2) ||
                (preYear === endYear && endSeason < 2),
              'right'
            )
          "
          :disabled="
            preYear > maxYear ||
            (preYear === maxYear && currSeason < 2) ||
            (preYear === endYear && endSeason < 2)
          "
          @click="selectSeason(1)"
          >第二季度</el-button
        >
      </div>
      <div class="text item" style="text-align: center">
        <el-button
          type="text"
          size="medium"
          :class="
            showDisabled(
              preYear > maxYear ||
                (preYear === maxYear && currSeason < 3) ||
                (preYear === endYear && endSeason < 3),
              'left'
            )
          "
          :disabled="
            preYear > maxYear ||
            (preYear === maxYear && currSeason < 3) ||
            (preYear === endYear && endSeason < 3)
          "
          @click="selectSeason(2)"
          >第三季度</el-button
        >
        <el-button
          type="text"
          size="medium"
          :class="
            showDisabled(
              preYear > maxYear ||
                (preYear === maxYear && currSeason < 4) ||
                (preYear === endYear && endSeason < 4),
              'right'
            )
          "
          :disabled="
            preYear > maxYear ||
            (preYear === maxYear && currSeason < 4) ||
            (preYear === endYear && endSeason < 4)
          "
          @click="selectSeason(3)"
          >第四季度</el-button
        >
      </div>
    </el-card>
    <el-card
      class="box-card box-card_right"
      style="
        width: 220px;
        padding: 0 3px 20px;
        margin-left: 192px;
        margin-top: 5px;
        z-index: 9999;
        position: absolute;
      "
      v-show="showEndSeason"
    >
      <div
        slot="header"
        class="clearfix"
        style="text-align: center; padding: 0"
      >
        <button
          type="button"
          aria-label="前一年"
          class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
          :disabled="showEndSeason && endYear <= preYear"
          @click="prev"
        ></button>
        <span
          v-if="showPreSeason"
          role="button"
          class="el-date-picker__header-label"
          >{{ preYear }}年</span
        >
        <span
          v-if="showEndSeason"
          role="button"
          class="el-date-picker__header-label"
          >{{ endYear }}年</span
        >
        <button
          type="button"
          aria-label="后一年"
          @click="next"
          class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
          :disabled="showPreSeason && preYear >= endYear"
        ></button>
      </div>
      <div class="text item" style="text-align: center">
        <el-button
          type="text"
          size="medium"
          :class="
            showDisabled(
              endYear > maxYear ||
                (endYear === maxYear && currSeason < 1) ||
                (preYear === endYear && preSeason > 1),
              'left'
            )
          "
          :disabled="
            endYear > maxYear ||
            (endYear === maxYear && currSeason < 1) ||
            (preYear === endYear && preSeason > 1)
          "
          @click="selectSeason(0)"
          >第一季度</el-button
        >
        <el-button
          type="text"
          size="medium"
          :disabled="
            endYear > maxYear ||
            (endYear === maxYear && currSeason < 2) ||
            (preYear === endYear && preSeason > 2)
          "
          :class="
            showDisabled(
              endYear > maxYear ||
                (endYear === maxYear && currSeason < 2) ||
                (preYear === endYear && preSeason > 2),
              'right'
            )
          "
          @click="selectSeason(1)"
          >第二季度</el-button
        >
      </div>
      <div class="text item" style="text-align: center">
        <el-button
          type="text"
          size="medium"
          :class="
            showDisabled(
              endYear > maxYear ||
                (endYear === maxYear && currSeason < 3) ||
                (preYear === endYear && preSeason > 3),
              'left'
            )
          "
          :disabled="
            endYear > maxYear ||
            (endYear === maxYear && currSeason < 3) ||
            (preYear === endYear && preSeason > 3)
          "
          @click="selectSeason(2)"
          >第三季度</el-button
        >
        <el-button
          type="text"
          size="medium"
          :class="
            showDisabled(
              endYear > maxYear ||
                (endYear === maxYear && currSeason < 4) ||
                (preYear === endYear && preSeason > 4),
              'right'
            )
          "
          :disabled="
            endYear > maxYear ||
            (endYear === maxYear && currSeason < 4) ||
            (preYear === endYear && preSeason > 4)
          "
          @click="selectSeason(3)"
          >第四季度</el-button
        >
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  props: {
    valueArr: {
      default: () => {
        return ["01", "02", "03", "04"];
      },
      type: Array,
    },
    getValue: {
      default: () => {},
      type: Function,
    },
    defaultValue: {
      default: () => {
        return ["2020-1", "2020-4"];
      },
      type: Array,
    },
  },
  computed: {
    showDisabled() {
      return function (status, type) {
        if (status) {
          if (type === "left") {
            return "text-show-left-dis";
          } else {
            return "text-show-right-dis";
          }
        } else {
          if (type === "left") {
            return "text-show-left";
          } else {
            return "text-show-right";
          }
        }
      };
    },
  },
  data() {
    return {
      showEndSeason: false,
      showPreSeason: false,
      preSeason: "",
      endSeason: "",
      preYear: new Date().getFullYear(),
      endYear: new Date().getFullYear(),
      showPreValue: "",
      showEndValue: "",
      varlues: "",
      maxYear: new Date().getFullYear(),
      currSeason: 2,
    };
  },
  created() {
    this.getNowQuarter();
    if (this.defaultValue && this.defaultValue.length === 2) {
      let preValue = this.defaultValue[0];
      let endValue = this.defaultValue[1];
      let arr = preValue.split("-");
      this.preYear = parseInt(arr[0]);
      this.preSeason = parseInt(arr[1]);
      this.showPreValue = `${this.preYear}年${this.preSeason}季度`;
      arr = endValue.split("-");
      this.endYear = parseInt(arr[0]);
      this.endSeason = parseInt(arr[1]);
      this.showEndValue = `${this.endYear}年${this.endSeason}季度`;
    }
  },
  watch: {
    defaultValue: function (value, oldValue) {
      let preValue = this.defaultValue[0];
      let endValue = this.defaultValue[1];
      let arr = preValue.split("-");
      this.preYear = parseInt(arr[0]);
      this.preSeason = parseInt(arr[1]);
      this.showPreValue = `${this.preYear}年${this.preSeason}季度`;
      arr = endValue.split("-");
      this.endYear = parseInt(arr[0]);
      this.endSeason = parseInt(arr[1]);
      this.showEndValue = `${this.endYear}年${this.endSeason}季度`;
    },
  },
  methods: {
    getNowQuarter() {
      var today = new Date();
      var selectMonth = today.getMonth() + 1; //getMonth返回0-11
      //下面是几个if
      if (selectMonth >= 1 && selectMonth <= 3) this.currSeason = 1;
      else if (selectMonth >= 4 && selectMonth <= 6) {
        this.currSeason = 2;
      } else if (selectMonth >= 7 && selectMonth <= 9) {
        this.currSeason = 3;
      } else if (selectMonth >= 10 && selectMonth <= 12) {
        this.currSeason = 4;
      }
    },
    one() {
      this.showEndSeason = false;
      this.showPreSeason = false;
    },
    prev() {
      if (this.showPreSeason) {
        this.preYear = this.preYear * 1 - 1;
      } else {
        this.endYear = this.endYear * 1 - 1;
      }
    },
    next() {
      if (this.showPreSeason) {
        this.preYear = this.preYear * 1 + 1;
      } else {
        this.endYear = this.endYear * 1 + 1;
      }
    },
    selectSeason(i) {
      let that = this;
      if (this.showPreSeason) {
        that.preSeason = i + 1;
        this.showPreValue = `${this.preYear}年${this.preSeason}季度`;
      } else {
        that.endSeason = i + 1;
        this.showEndValue = `${this.endYear}年${this.endSeason}季度`;
      }
      this.varlues = [
        that.preYear + "-" + this.preSeason,
        that.endYear + "-" + this.endSeason,
      ];
      that.$emit("getQuarter", this.varlues);
      that.showEndSeason = false;
      that.showPreSeason = false;
    },
  },
};
</script>
<style>
.text-show-left {
  float: left;
  width: 40%;
  color: #666666;
}
.text-show-right {
  float: right;
  width: 40%;
  color: #666666;
}
.text-show-left-dis {
  float: left;
  width: 40%;
  color: #c0c4cc;
}
.text-show-right-dis {
  float: right;
  width: 40%;
  color: #c0c4cc;
}
#text .el-input__icon {
  line-height: 28px;
}
#text .el-input__inner {
  line-height: 28px !important;
  height: 28px !important;
  font-size: 12px;
}
@media (min-width: 1200px) {
  .jiance_phone_date_1 {
    width: 120px !important;
  }
  .jiance_phone_date_1 .el-input__inner {
    width: 120px !important;
  }
}
@media (max-width: 1200px) {
  .rightInputBox {
    margin-left: 36px;
    margin-top: 6px;
  }
  .box-card_left {
    top: 26px;
    left: 0;
  }
  .box-card_right {
    margin-left: 0 !important;
  }
}
</style>